module.exports = __webpack_public_path__ + "img/ico-arrow-up-grey.77f78530.svg";